export default __webpack_public_path__ + "static/media/commissions2.5099c469.svg";